// extracted by mini-css-extract-plugin
export default {"section":"HomeContent_section__nQ9U5"};